import React from "react";
import '../../../styles/components/onboarding/info/info-navigation.scss';
import NavigationDots from "../../common/NavigationDots";
import Button from "../../common/Button";
import {useTrialNavigation} from "../../../hooks/trialNavigation.hook";
import {inAppAnalyticsService} from "../../../services/inAppAnalyticsService";

const screenClass = 'onboarding/info';

export default function InfoNavigation({currentIndex, onNextClick}: {currentIndex: number, onNextClick: ()=> void}) {
  const {navigateToAppropriateAccountCreationPage} = useTrialNavigation();

  return (
    <div className="info-navigation">
      <NavigationDots totalDots={4} currentIndex={currentIndex}/>
      <div className="buttons">
        <Button text={"Skip Intro"} buttonType={"secondary"} onClick={()=>{
          inAppAnalyticsService.onButton_press('onboarding-info-skip-intro', {screenClass});
          navigateToAppropriateAccountCreationPage();
        }}/>
        <Button text={"Next"} onClick={()=>{
          inAppAnalyticsService.onButton_press('onboarding-info-next', {screenClass});
          onNextClick();
        }}/>
      </div>
    </div>
  );
}
